import React from "react";
import { useEffect, useState } from "react";
import { api } from 'api';

/**
 * Hook para obtener las recepciones de fletes y sus totales
 * @returns {Object} - Objeto con las funciones para obtener las recepciones de fletes y el estado de carga
 */
export const RecepcionesFletesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRecepcionesFletes = async (params) => {
        try {
            setCargando(true);
            const response = await api.get('finca_bonif_fletes/get_recepciones_fletes', params);
            return response;
        } catch (error) {
            console.error(error);
            return { results: 0, data: [] };
        } finally {
            setCargando(false);
        }
    }

    const getTotalesFletes = async (params) => {
        try {
            setCargando(true);
            const response = await api.get('finca_bonif_fletes/get_totales_fletes', params);
            return response;
        } catch (error) {
            console.error(error);
            return {};
        } finally {
            setCargando(false);
        }
    }



    return {
        getRecepcionesFletes,
        getTotalesFletes,
        cargando
    }
}
